/**
 * 动态桑基图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const dynamicSankeyValidationConfig: ValidationConfig = {
  fields: [
    { field: 'name', type: 'string', required: true },
    { field: 'value', type: 'number', required: true },
    { field: 'target', type: 'array', required: true },
    { field: 'date', type: ['string', 'date'], required: true },
    { field: 'valueText', type: ['string', 'number'], required: false },
    { field: 'describe', type: 'string', required: false },
    { field: 'unit', type: 'string', required: false },
    { field: 'otherInfo', type: 'array', required: false }
  ],
  businessRules: [
    {
      name: 'dynamic-sankey-depth-property',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return false;
        }
        return data.every(item => 'depth' in item && typeof item.depth === 'number');
      },
      message: 'Dynamic Sankey nodes must have depth property',
      suggestion: 'Add depth property to each node indicating its hierarchical level',
      severity: 'error'
    },
    {
      name: 'dynamic-sankey-root-node',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return false;
        }
        return data.some(item => Boolean(item.root));
      },
      message: 'Dynamic Sankey must have at least one root node',
      suggestion: 'Set root=true for at least one node to serve as the starting point',
      severity: 'error'
    },
    {
      name: 'dynamic-sankey-item-style',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return false;
        }
        return data.every(item => 'itemStyle' in item && typeof item.itemStyle === 'object');
      },
      message: 'Dynamic Sankey nodes must have itemStyle property',
      suggestion: 'Add itemStyle object to each node for visual styling configuration',
      severity: 'error'
    },
    {
      name: 'dynamic-sankey-target-array',
      validator: (data, layer) => {
        const { encoding } = layer;
        if (!Array.isArray(data)) {
          return false;
        }
        return data.every(item => {
          const target = item[encoding?.target as string];
          return Array.isArray(target);
        });
      },
      message: 'Dynamic Sankey target field must be an array',
      suggestion: 'Ensure target field contains an array of connected node references',
      severity: 'error'
    },
    {
      name: 'dynamic-sankey-value-positive',
      validator: (data, layer) => {
        const { encoding } = layer;
        if (!Array.isArray(data)) {
          return false;
        }
        return data.every(item => {
          const value = item[encoding?.value as string];
          return typeof value === 'number' && value >= 0;
        });
      },
      message: 'Dynamic Sankey values should be non-negative',
      suggestion: 'Ensure all value fields contain non-negative numbers',
      severity: 'warning'
    }
  ]
};
